<template>
  <div class="complaint-manage" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>投诉类型</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.type" class="app-block" placeholder="请选择投诉类型">
              <a-select-option :value="value" v-for="value in typeOptions" :key="value">{{value}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>投诉用户</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入投诉用户" v-model="table.search.user"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>投诉内容</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入投诉内容" v-model="table.search.content"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="scanComment(data)">查看</a-button>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="50%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <invitation-details :id="drawer.id" :community-id="communityId"></invitation-details>
    </a-drawer>
  </div>
</template>

<script>
  import ComplaintService from '@/io/complaint.js';
  import SectionService from '@/io/section.js';
  import InvitationDetails from '@/views/community/InvitationDetails.vue';

  export default {
    name: 'CommentManage',
    props: {
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            type: [],
            user: null,
            content: null
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '投诉内容',
              dataIndex: 'content'
            },
            {
              title: '所属版块',
              dataIndex: 'category.name'
            },
            {
              title: '投诉类型',
              dataIndex: 'type'
            },
            {
              title: '投诉用户',
              dataIndex: 'username'
            },
            {
              title: '投诉时间',
              dataIndex: 'created_at'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        typeOptions: [],
        drawer: {
          id: null,
          title: '帖子详情',
          show: false,
        }
      }
    },
    components: {
      InvitationDetails,
    },
    watch: {
      communityId: {
        handler(newValue, oldValue) {
          if (newValue || this.$getCookie('communityId')) {
            this.initType().then(() => {
              this.searchTable();
            });
          }
        },
        immediate: true
      }
    },
    methods: {
      scanComment(data) {
        this.drawer.id = data.post_id;
        this.drawer.show = true;
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          type: [],
          user: null,
          content: null
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initType() {
        return ComplaintService.type().then(res => {
          this.typeOptions = res;
        }).catch(err => {});
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        ComplaintService.listPage(
          this.communityId,
          this.table.search.type,
          this.table.search.user,
          this.table.search.content,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>